import { render } from "./ValidatorStakeChanges.vue?vue&type=template&id=942b7100&scoped=true"
import script from "./ValidatorStakeChanges.vue?vue&type=script&lang=js"
export * from "./ValidatorStakeChanges.vue?vue&type=script&lang=js"

import "./ValidatorStakeChanges.vue?vue&type=style&index=0&id=942b7100&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-942b7100"],['__file',"resources/js/components/ValidatorStakeChanges.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "942b7100"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('942b7100', __exports__)) {
    api.reload('942b7100', __exports__)
  }
  
  module.hot.accept("./ValidatorStakeChanges.vue?vue&type=template&id=942b7100&scoped=true", () => {
    api.rerender('942b7100', render)
  })

}


export default __exports__